import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgAnnouncement(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 6C17.5523 6 18 6.44772 18 7V16C18 16.5523 17.5523 17 17 17C16.4477 17 16 16.5523 16 16V7C16 6.44772 16.4477 6 17 6ZM15.2616 6.01045C15.6059 5.40689 16.2554 5 17 5C18.1046 5 19 5.89543 19 7V16C19 17.1046 18.1046 18 17 18C16.266 18 15.6243 17.6046 15.2764 17.0152L11.3441 15.9264L12.3877 19.0802C12.5376 19.5332 12.2003 20.0001 11.7232 20.0001H9.73987C9.07522 20.0001 8.48982 19.5628 8.30141 18.9254L7.13546 14.9812C5.37377 14.7989 4 13.3099 4 11.5C4 9.567 5.567 8 7.5 8H8.02352L15.2616 6.01045ZM10.1845 15.6053L8.20031 15.0559L9.26038 18.6419C9.32319 18.8543 9.51832 19.0001 9.73987 19.0001H11.3079L10.1845 15.6053ZM9 14.2397L15 15.901V7.11944L9 8.76868V14.2397ZM8 9H7.5C6.11929 9 5 10.1193 5 11.5C5 12.8807 6.11929 14 7.5 14H8V9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);

var AnnouncementOutline = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { AnnouncementOutline as default };
